import React from "react";
import { Route, Redirect } from "react-router-dom"
import { authenticateOwner, isAuthenticated } from "./app/Components/SignIn/helper/SigninHelper";

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect to='/' />
        )
      }
    />
  );
};

export const OwnerPrivateRoute = ({ component: Component, ...rest }) => {
  const isOwnerLogin = authenticateOwner();
  return (
    <Route
      {...rest}
      render={props =>
        isOwnerLogin ? (
          <Component {...props} />
        ) : (
          <Redirect to='/page-not-found' />
        )
      }
    />
  );
};
export default PrivateRoute;